import { memo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Button, Heading, Text } from '@zillow/constellation-10';

import { useSelector } from '../../../selectors/useSelector';

import PropertiesActions from '../../../actions/PropertiesActions';
import SpecialOffersModal from '../../Modal/SpecialOffersModal';
import SpecialOfferContainer from './components/SpecialOfferContainer';

import { SPECIAL_OFFERS_ACTIONS } from '../../../constants/SpecialOffersConstants';
import { TRIGGER_LOCATIONS } from '../../../constants/ClickstreamConstants';

import InfoPopover from './components/InfoPopover';

type Props = {
  isRelistingFieldset?: boolean;
};
const SpecialOffers = ({ isRelistingFieldset = false }: Props) => {
  const dispatch = useDispatch();

  const {
    properties: {
      currentProperty,
      currentProperty: { specialOffers },
    },
    user,
  } = useSelector((state) => state);

  const defaultOfferProps = specialOffers.length > 0 ? { defaultOffer: specialOffers[0] } : null;
  const firstClickToAddOfferTrackingLocation = isRelistingFieldset
    ? TRIGGER_LOCATIONS.POSTING_PATH_REVIEW
    : TRIGGER_LOCATIONS.POSTING_PATH;
  const firstClickToAddOfferTrackingProps =
    specialOffers.length === 0 ? { firstClickToAddOfferTrackingLocation } : null;
  const heading = specialOffers.length > 0 ? 'Current Special Offer' : 'Do you want to promote a special offer?';
  const [showSpecialOffersModal, setShowSpecialOffersModal] = useState(false);
  const [modalAction, setModalAction] = useState(SPECIAL_OFFERS_ACTIONS.ADD);

  const handleAddSpecialOfferClick = (action: string) => {
    setModalAction(action);
    setShowSpecialOffersModal(true);
  };
  // @ts-expect-error
  const updateCurrentProperty = (specialOffers) => dispatch(PropertiesActions.updateCurrentProperty(specialOffers));

  return (
    <Box data-testid="SpecialOffers" css={{ marginBottom: '1200' }}>
      {isRelistingFieldset ? (
        <Box css={{ display: 'flex', flexDirection: 'row', marginBottom: '100' }}>
          <Text textStyle="body-sm-bold" asChild>
            <p>{heading}</p>
          </Text>
          <InfoPopover
            currentProperty={currentProperty}
            user={user}
            triggerLocation={TRIGGER_LOCATIONS.POSTING_PATH_REVIEW}
          />
        </Box>
      ) : (
        <Box css={{ display: 'flex', flexDirection: 'row', marginTop: { base: 0, lg: '600' }, marginBottom: '800' }}>
          <Heading level={5}>{heading}</Heading>
          <InfoPopover currentProperty={currentProperty} user={user} triggerLocation={TRIGGER_LOCATIONS.POSTING_PATH} />
        </Box>
      )}
      {specialOffers.length <= 0 ? (
        <Button
          onClick={() => handleAddSpecialOfferClick(SPECIAL_OFFERS_ACTIONS.ADD)}
          tone="neutral"
          emphasis="outlined"
          size="md"
          css={{ marginRight: '800' }}
        >
          Add an offer
        </Button>
      ) : (
        <Box css={{ marginTop: isRelistingFieldset ? '200' : '800' }}>
          <SpecialOfferContainer
            isInPostingPath={true}
            onEditOfferClick={() => handleAddSpecialOfferClick(SPECIAL_OFFERS_ACTIONS.EDIT)}
          />
        </Box>
      )}

      {showSpecialOffersModal && (
        <SpecialOffersModal
          action={modalAction}
          setShowSpecialOffersModal={setShowSpecialOffersModal}
          {...defaultOfferProps}
          {...firstClickToAddOfferTrackingProps}
        />
      )}
    </Box>
  );
};

export default memo(SpecialOffers);
